import { Component, OnInit, OnDestroy } from '@angular/core';
import { Localization } from "../enums/localization";
import { PermissionsService } from '../services/permissions-service';
import { Permission } from '../enums/enums';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-forbidden-page',
  templateUrl: './forbidden-page.component.html',
  styleUrls: ['./forbidden-page.component.scss']
})
export class ForbiddenPageComponent implements OnInit, OnDestroy {
  private subscriptions: Subscription[];

  public hasManagerPermission: boolean;

  public readonly Localization = Localization;

  constructor(private permissionsService: PermissionsService) {
    this.subscriptions = [];
  }

  ngOnInit() {
    this.subscriptions.push(this.permissionsService.doesUserHavePermission(Permission.MANAGER).subscribe((result) => {
      this.hasManagerPermission = result;
    }));
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

}
